import type { TealiumEventData } from 'src/types/trackingData';

const JOB_SECTION_VIEWED = 'job_section_viewed';
export const editSectionLinkClicked: TealiumEventData = {
  linkName: JOB_SECTION_VIEWED,
  eventName: [JOB_SECTION_VIEWED],
};

const JOB_PUBLISH_PRESSED = 'job_publish_pressed';
export const editPublishButtonClicked: TealiumEventData = {
  linkName: JOB_PUBLISH_PRESSED,
  eventName: [JOB_PUBLISH_PRESSED],
};

const JOB_CHECKOUT_PRESSED = 'job_checkout_pressed';
export const editCheckoutButtonClicked: TealiumEventData = {
  linkName: JOB_CHECKOUT_PRESSED,
  eventName: [JOB_CHECKOUT_PRESSED],
};

const DISCARD_CHANGES_PRESSED = 'discard_changes_pressed';
export const editDiscardButtonClicked: TealiumEventData = {
  linkName: DISCARD_CHANGES_PRESSED,
  eventName: [DISCARD_CHANGES_PRESSED],
};

const KEEP_EDITING_PRESSED = 'keep_editing_pressed';
export const editKeepButtonClicked: TealiumEventData = {
  linkName: KEEP_EDITING_PRESSED,
  eventName: [KEEP_EDITING_PRESSED],
};
